export default {
  search: 'Search',
  searchPlaceholder: 'Search games...',
  logIn: 'Log In',
  signUp: 'Sign Up',
  logOut: 'Log Out',
  account: 'Account',
  myOrders: 'My orders',
  favorites: 'Favorites',
  cart: 'Cart',
  viewMore: 'View more',
  browseCatalog: 'Browse catalog',
  startingAt: 'Starting at',
  baseGame: 'Base game',
  retry: 'Retry',
  close: 'Close',
  loading: 'Loading…',
  noImage: 'No image',
  searchCountry: 'Search country…',
  noResults: 'No results',
};
